import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Pulse from 'react-reveal/Pulse';
import projectImg from '../assets/images/projectImg.png';
import CPButton from './CPButton';

const ProjectItemStyles = styled.div`
  .projectItem__img {
    width: 100%;
    height: 400px;
    border-radius: 12px;
    overflow: hidden;
    display: inline-block;
    border: 3px solid var(--gray-2);
    img {
      height: 100%;
      object-fit: fill;
    }
  }
  .projectItem__info {
    margin-top: 1rem;
    background-color: var(--deep-dark);
    padding: 1rem;
    border-radius: 12px;
  }
  .projectItem__title {
    font-size: 2.2rem;
  }
  .projectItem__desc {
    font-size: 1.6rem;
    font-family: 'RobotoMono Regular';
    margin-top: 1rem;
  }
  .button {
    display: flex;
    justify-content: space-between;
  }
  @media only screen and (max-width: 768px) {
    .projectItem__img {
      height: 350px;
    }
  }
`;

export default function ProjectItem({
  img = projectImg,
  title = 'Project Namr',
  desc = `Ea esse ullamco anim ipsum aute est amet velit. Dolore ullamco amet
    cillum consequat fugiat esse cupidatat ullamco. Minim amet culpa
    deserunt aute ullamco ullamco aliqua adipisicing duis. Aute enim
    deserunt proident Lorem.`,
  btnlink = '#',
  gitlink = '#',
}) {
  return (
    <ProjectItemStyles>
      <Link to="/projects" className="projectItem__img">
        <Pulse>
          <img src={img} alt="project img" />
        </Pulse>
      </Link>
      <div className="projectItem__info">
        <Link to="#">
          <h3 className="projectItem__title">{title}</h3>
        </Link>
        <p className="projectItem__desc">{desc}</p>
        <div className="button">
          <CPButton btnText="Demo" btnLink={btnlink} />

          <CPButton btnText="Github" btnLink={gitlink} outline="true" />
        </div>
      </div>
    </ProjectItemStyles>
  );
}
